import { API } from "aws-amplify";

export const RUN_REPLACEMENT_REQUEST = "@@replacement/RUN_REPLACEMENT_REQUEST";
export const RUN_REPLACEMENT_SUCCESS = "@@replacement/RUN_REPLACEMENT_SUCCESS";
export const RUN_REPLACEMENT_FAILURE = "@@replacement/RUN_REPLACEMENT_FAILURE";

export function checkRunReplacement(formData) {
    return async (dispatch) => {
        dispatch({
            type: RUN_REPLACEMENT_REQUEST,
        });
        try {
            const body = {
                body: formData,
            };
            const response = await API.post(
                "cmsAPI",
                `/replacement`,
                body
            );
            dispatch({
                type: RUN_REPLACEMENT_SUCCESS,
                payload: response,
            });
            return response;
        } catch (error) {
            dispatch({
                type: RUN_REPLACEMENT_FAILURE,
                payload: error,
            });
            return undefined;
        }
    };
}